import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Shrinkage extends Bloc {

	constructor (src, ctx) {

		super("shrinkage", src, ctx, true);
		this.f = (src, ins) => {

			src.master.player.shrink(ins[0]);
			return [];
		};
		this.types = [Types.int];
	}
}